import { MLP_NAVBAR_LOGO } from '@/common/constants/mlp';
import type { NavbarProps } from '@/components/global/Navbar/types';

const EB = 'https://www.eventbrite.com';

/**
 * Minimal static NavBar used on standalone pages (e.g. product roadmap) that
 * live outside the regular organizer MLP container.
 */
export const NAVBAR_FALLBACK: NavbarProps = {
  title: MLP_NAVBAR_LOGO,
  titleLink: `${EB}/organizer/overview/`,
  navItems: [],
  ctas: [
    { label: 'Contact Sales', link: `${EB}/organizer/contact-sales/`, type: 'secondary' },
    { label: 'Get Started', link: `${EB}/creator/onboarding/guest-start/`, type: 'primary' },
  ],
};
